// feat: preferencias de notificaciones por usuario (PREF#notifications)
import { z } from 'zod';

export const REMINDER_TIME_PATTERN = /^([01]\d|2[0-3]):[0-5]\d$/;

export const notificationPrefsSchema = z
  .object({
    emailStreakMilestone: z.boolean().optional(),
    emailBadgeEarned: z.boolean().optional(),
    dailyReminderEnabled: z.boolean().optional(),
    dailyReminderTime: z
      .string()
      .regex(REMINDER_TIME_PATTERN, 'Formato de hora inválido (HH:MM)')
      .optional(),
  })
  .refine((prefs) => Object.values(prefs).some((v) => v !== undefined), {
    message: 'At least one preference must be provided',
  });

export type NotificationPrefsInput = z.infer<typeof notificationPrefsSchema>;

export interface NotificationPrefs {
  emailStreakMilestone: boolean;
  emailBadgeEarned: boolean;
  /** Recordatorio diario de estudio (email) */
  dailyReminderEnabled: boolean;
  /** Hora local del recordatorio diario, formato "HH:MM" */
  dailyReminderTime: string;
}

export const DEFAULT_NOTIFICATION_PREFS: NotificationPrefs = {
  emailStreakMilestone: true,
  emailBadgeEarned: true,
  dailyReminderEnabled: false,
  dailyReminderTime: '09:00',
};
